import { useEffect, useState, useContext } from "react";
import { useHistory } from "react-router";


import { SPOCListTable } from "./SPOCList/SPOCListTable";
import { DoctorProfileStatusFilter } from "../DoctorMangement/AddDoctor/DoctorListFilter";
import { DoctorStatusFilter } from "../DoctorMangement/AddDoctor/DoctorStatusFilter";
import { EmptySpocList } from "./EmptySpocList";
import { getSPOCDetails } from "./Helper/API"
import { getSpecialityList, getUserDetails } from "../DoctorMangement/Helper/utils";
import { BackdropLoader } from '../DoctorMangement/BackdropLoader';
import { FEATURE_NAME, Services } from "../DoctorMangement/constant";
import { HowToUse } from "../centralOms/common/howToUseDialog";
import { getUrlForSPOCProfilePage } from "./Helper/utils"
import UserFeaturesContext  from '../../hook/UserDetails/UserFeaturesContext'; // Import the context
import { getFeaturesForUser, getServiceFilter } from "./Helper/utils"
import TopNavBarSPOC from "./TopNavBarSPOC";
import { ToastEmitter } from "../DoctorMangement/ToastEmitter";
import { checkFeatureFeasbility } from "../../helper/utils";
import { fetchUserDetailsAndSetUserForAnalytics, logEventToAnalyticsPlatform } from "../../helper/events";
import {EVENTS } from "../DoctorMangement/events_Constant"
import { SPOC_VIDEO_URL } from "./constant";
import { Tooltip } from "@mui/material";
import { ODIcon } from "../DoctorMangement/ODIcon";

export const SPOCList = () => {
  const [page, setPage] = useState(1);
  const history = useHistory();
  const [activeProfileStausFilter, setActiveProfileStausFilter] = useState(1);
  const [activeServicesFilterArray, setActiveServicesFilterArray] = useState([]);
  const [activeSpecialityFilterArray, setActiveSpecialityFilterArray] = useState([]);
  const [isFilterActive, setIsFilterActive] = useState(false);
  const [totalRecords, setTotalRecords] = useState(-1);
  const [SPOCList, setSPOCList] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingUserFeature, setIsLoadingUserFeature] = useState(false);
  const [howToUseDialogVisible, setHowToUseDialogVisibiliy] = useState(false);
  const [selectedProviders, setSelectedProviders] = useState([]);
  const [specialityArray,setSpecialityArray] = useState([]);

  const { userFeatures, OFCSpeciality, saveUserFeatures } = useContext(UserFeaturesContext);

  const fetchSPOCList = async () => {
    try {
      setIsLoading(true);
      let user_details = getUserDetails();
      let profileStatus

      //API take value in boolean and 0 for false and 1 for true
      if(activeProfileStausFilter == 0){
          profileStatus = false;
      }
      if(activeProfileStausFilter == 1){  
          profileStatus = true;
      }
      
      const serviceFilter = getServiceFilter(activeServicesFilterArray);
      
      let data = {
        entityId: user_details.entityId,
        ...(activeProfileStausFilter !== undefined && { profileStatus: [profileStatus] }),
        speciality: activeSpecialityFilterArray,
        service: serviceFilter,
        startIndex: page,
        range: 10,
        filterEntityIds:selectedProviders?.length ? selectedProviders.map((val) => parseInt(val.id)) : [],
        applicationId: 10007, //this is constant
      }
      const resp = await getSPOCDetails(data);
      setSPOCList(resp);
      if (page === 1) {
        setTotalRecords(resp.count);
      }
      logEventToAnalyticsPlatform({
        name: EVENTS.PC_LS_ACTION.name,
        payload: {
          tab_name: EVENTS.TAB_NAME_LC_SCREEN,
          reference_id: '',
          reference_provider_id: '',
          filterValue: JSON.stringify([...activeServicesFilterArray, ...activeSpecialityFilterArray, { profileStatus: activeProfileStausFilter != null ? activeProfileStausFilter : null}]),
          service_name: EVENTS.SERVICE_NAME_SPOC,
          action: EVENTS.ACTION.FILTER,
        },
        schema: EVENTS.PC_LS_ACTION.schema,
      })

      setIsLoading(false);

    } catch (err) {
      setSPOCList([]);
      setIsLoading(false);
      ToastEmitter('Failed To Load SPOC List', 'error');
    }
  };


  useEffect(() => {
    const saveUserFeaturesInContextHook = async () => {
      if (userFeatures) return;
      setIsLoadingUserFeature(true);
      const {userFeature, userRoles} = await getFeaturesForUser(history)
      saveUserFeatures(userFeature, userRoles);
      setIsLoadingUserFeature(false);
    }
    saveUserFeaturesInContextHook();
  }, []);

  useEffect(() => {
    fetchSPOCList();
  }, [page]);

  useEffect(() => {
    if (activeProfileStausFilter !== undefined && activeProfileStausFilter != null || activeServicesFilterArray.length || activeSpecialityFilterArray.length) {
      setIsFilterActive(true);
    }
    else {
      setIsFilterActive(false);
    }
    if (page === 1) {
      fetchSPOCList();
    } else {
      setPage(1);
    }
  }, [activeProfileStausFilter, activeServicesFilterArray, activeSpecialityFilterArray]);

  const clearAllFilter = () => {
    setActiveProfileStausFilter();
    setActiveServicesFilterArray([]);
    setActiveSpecialityFilterArray([]);
    setIsFilterActive(false);
  }

  useEffect(() => {
    const triggerEvents = async () => {
      await fetchUserDetailsAndSetUserForAnalytics();
      logEventToAnalyticsPlatform({
        name: EVENTS.PC_SCREEN_LANDING.name,
        payload: {
          tab_name: EVENTS.TAB_NAME_LC_SCREEN,
          service_type: EVENTS.SERVICE_TYPE_SPOC,
          screenName: EVENTS.SERVICE_NAME_SPOC,
        },
        schema: EVENTS.PC_SCREEN_LANDING.schema,
      })
    }
    triggerEvents();

  }, [])


  useEffect(() => {
    const specialityArray = getSpecialityList(OFCSpeciality);
    setSpecialityArray(specialityArray)
  }, [OFCSpeciality])

  return (
    <>
      {(isLoading || isLoadingUserFeature) && <BackdropLoader isLoading={isLoading || isLoadingUserFeature} />}
      <TopNavBarSPOC   setIsLoading={setIsLoading}  setDoctorList={setSPOCList} setTotalRecords={setTotalRecords} activeServicesFilterArray={activeServicesFilterArray} activeSpecialityFilterArray={activeSpecialityFilterArray} activeProfileStausFilter={activeProfileStausFilter}  setSelectedProviders={setSelectedProviders} selectedProviders={selectedProviders} ></TopNavBarSPOC>
      <div className="p-8 flex flex-row justify-between ">
        <div className="flex flex-row gap-4 align-center justify-center">
          <div className="text-3xl font-bold text-[#252D38] pt-1">
            SPOC List
          </div>

          <div className="flex justify-center gap-2">
          <button className="flex justify-center border rounded-lg border-blue-700 pt-3 pb-1 pr-2 pl-1 text-blue-700 font-['Lexend_Deca'] text-sm font-semibold p-2"
             onClick={() => setHowToUseDialogVisibiliy(true)}>
            <img src="assets/play-circle.svg"
              style={{ width: 34, marginTop: -5, height: 29 }}
              alt="video play"
              className='relative justify-center items-center' />
            How To use
          </button>
            <Tooltip
              title={
              <span
                className="block text-sm font-medium text-white leading-snug opacity-100  backdrop-blur-md rounded-lg px-1 py-2 shadow-lg"
              >
                Contact MediBuddy support <br/>at +91 99999 91555 for help.
              </span>
              }
              arrow
            >
              <span className=" flex items-center justify-center cursor-pointer px-1" style={{ minWidth: "2.5rem", minHeight: "2.5rem" }}>
                <ODIcon
                  src="/assets/chat.png"
                  width={32}
                  height={32}
                  className="inline-block"
                  alt="Support Info"
                />
              </span>
            </Tooltip>
          </div>
        </div>
        {checkFeatureFeasbility(FEATURE_NAME.CREATE_SPOC,userFeatures) && <button className="flex justify-center border border-blue-700 font-semibold text-sm bg-blue-600 text-white rounded-lg pb-2.5 pt-2.5 px-3"
          style={{ 'paddingBottom': '0.75rem', 'paddingTop': '0.75rem' }}
          onClick={() => {
            const routeUrl = getUrlForSPOCProfilePage();
            logEventToAnalyticsPlatform({
              name: EVENTS.PC_LS_ACTION.name,
              payload: {
                tab_name: EVENTS.TAB_NAME_LC_SCREEN,
                filterValue: JSON.stringify([...activeServicesFilterArray, ...activeSpecialityFilterArray, { profileStatus: activeProfileStausFilter != null ? activeProfileStausFilter : null}]),
                service_name: EVENTS.SERVICE_NAME_SPOC,
                action: EVENTS.ACTION.SPOC_ADD,
              },
              schema: EVENTS.PC_LS_ACTION.schema,
            })
            history.push(routeUrl);
          }}>
          <img src="assets/plus.svg" alt="" height={20} width={20} className="mr-1" />
          Add new SPOC
        </button>}
      </div>
      {totalRecords === 0  && !SPOCList?.user ? (
        <EmptySpocList />
      ) :
        (
          <>
            <div className="flex flex-row ">
              <DoctorStatusFilter
                filterTitle="Profile Status"
                activeFilter={activeProfileStausFilter}
                setActiveFilter={setActiveProfileStausFilter}
              />
              <DoctorProfileStatusFilter
                filterArray={Services}
                filterTitle="Services"
                activeFilterArray={activeServicesFilterArray}
                setActiveFilterArray={setActiveServicesFilterArray}
              />
              <DoctorProfileStatusFilter
                filterArray={specialityArray}
                filterTitle="Speciality"
                activeFilterArray={activeSpecialityFilterArray}
                setActiveFilterArray={setActiveSpecialityFilterArray}
              />

              <div
                className="flex flex-row justify-center items-center cursor-auto"
                onClick={isFilterActive ? clearAllFilter : null}
                style={{alignItems:'normal'}}
              >
                <p
                  className={`${isFilterActive ? "text-mb-red" : "text-[#BFC8D2]"
                    } font-normal text-base pt-8 pl-8 cursor-default`}
                >
                  Clear All
                </p>
                {isFilterActive ? (
                  <img
                    style={{ width: 32, height: 84 }}
                    src="https://views.medibuddy.in/providerUi/assets/filter-remove.svg"
                    alt="remove filter"
                    className="relative wpl-2"
                  />
                ) : (
                  <img
                    style={{ width: 32, height: 84 }}
                    src="https://views.medibuddy.in/providerUi/assets/filter.svg"
                    alt="remove filter"
                    className="relative justify-center items-center pl-2"
                  />
                )}
              </div>
            </div>
            <div className="">
              {SPOCList.user && totalRecords > 0 ? <SPOCListTable SPOCList={SPOCList} setPage={setPage} page={page} totalRecords={totalRecords} fetchSPOCDetails={fetchSPOCList} />
                : SPOCList?.user?.length === 0 && <EmptySpocList />
              }
            </div>
            {howToUseDialogVisible && <HowToUse visible={howToUseDialogVisible} setVisibility={setHowToUseDialogVisibiliy} videoURL={SPOC_VIDEO_URL}></HowToUse>}

          </>
        )
      }
    </>
  );
};
